import {useQuery, useQueryClient} from "@tanstack/react-query"
import {studentPaymentService} from "services"
import {StudentPaymentMethod} from "types/student-account/student-payment"

const queryCacheKey = "student-payment-methods"
const INITIAL_DATA: StudentPaymentMethod[] = []

export const useStudentPaymentMethods = ({profileId}: {profileId: number}) => {
    const queryClient = useQueryClient()

    const query = useQuery(
        [queryCacheKey, profileId],
        async () => await studentPaymentService.getStudentPaymentMethods(profileId),
        {}
    )

    return {
        paymentMethods: query.data ?? INITIAL_DATA,
        isLoading: query.isFetching,
        refetch: query.refetch
    }
}
